export default __webpack_public_path__ + "static/media/receipt.5869e09f.svg";